<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">MÜŞTERİ - TERMİNAL RAPORU</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Raporlar</li>
            <li class="breadcrumb-item active">Müşteri - Terminal Raporu</li>
        </ol>
    </div>


    <div class="data-grid">
        <p-table #dt [value]="bindData" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['projectName','customerName','serviceName','portalName','contractTypeName','contractNumber','numberOfTerminals']"
            [responsive]="true" [rowsPerPageOptions]="[5,10,25,50]" (onFilter)="filterData($event)">
            <ng-template pTemplate="caption">

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="Dışa Aktar" tooltipPosition="bottom"
                    label="Dışa Aktar"></button>


            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="customerName" [width]="'15%'">Müşteri<p-sortIcon field="customerName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="dealerName" [width]="'15%'">Bayi<p-sortIcon field="dealerName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="projectName" [width]="'15%'">Proje<p-sortIcon field="projectName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="portalName" [width]="'15%'">Portal<p-sortIcon field="portalName">
                        </p-sortIcon>
                    </th>

                    <th pSortableColumn="serviceName" [width]="'15%'">Hizmet<p-sortIcon field="serviceName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="serviceUnitPrice" [width]="'7%'">Hizmet Bedeli<p-sortIcon
                            field="serviceUnitPrice">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="commissionPrice" [width]="'8%'">Kmsyn Bedeli<p-sortIcon
                            field="commissionPrice">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="numberOfTerminals" [width]="'20%'">Adet<p-sortIcon field="numberOfTerminals">
                        </p-sortIcon>
                    </th>

                </tr>

                <tr>
                    <th>
                        <p-columnFilter field="customerName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="customers" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="customerName"
                                    optionValue="customerName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.customerName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="dealerName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="dealers" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="dealerName" optionValue="dealerName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.dealerName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="projectName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="projects" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="projectName" optionValue="projectName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.projectName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="portalName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="portals" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="portalName" optionValue="portalName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.portalName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                        <p-columnFilter field="serviceName" matchMode="in" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-multiSelect [ngModel]="value" [options]="services" placeholder="Tümü"
                                    (onChange)="filter($event.value)" optionLabel="serviceName" optionValue="serviceName">
                                    <ng-template let-option pTemplate="item">
                                        <div class="p-multiselect-representative-option">
                                            <span>{{option.serviceName}}</span>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>

                    </th>
                    <th>

                    </th>
                    <th>

                    </th>
                </tr>

            </ng-template>
            <ng-template pTemplate="body" let-customerTerminals>
                <tr>
                    <td>{{customerTerminals.customerName}}</td>
                    <td>{{customerTerminals.dealerName}}</td>
                    <td>{{customerTerminals.projectName}}</td>
                    <td>{{customerTerminals.portalName}}</td>
                    <td>{{customerTerminals.serviceName}}</td>
                    <td>{{customerTerminals.serviceUnitPrice| number: '1.0'}} {{customerTerminals.currencyUnit}}</td>
                    <td>{{customerTerminals.commissionPrice| number: '1.0'}} {{customerTerminals.currencyUnit}}</td>
                    <td> <span class="badge badge-dark"
                            style="font-size: 1.5rem;">{{customerTerminals.numberOfTerminals}}</span></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <br>
                <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class=""><span class="badge badge-dark" style="font-size: 1.2rem;">Toplam Adet:
                            {{calcTerminals()}}</span></th>
                </tr>
            </ng-template>
        </p-table>

    </div>
</div>